<template>
	<div class="content w-full">
		<TopNavbar/>
        <MyPackageComponent />
        <PackageInformationComponent />
	</div>	
</template>

<script>
import TopNavbar from '@/components/user/layout/TopNavbar.vue';
import MyPackageComponent from '@/components/user/viewComponent/package/MyPackageComponent.vue';
import PackageInformationComponent from '@/components/user/viewComponent/package/PackageInformationComponent.vue';
import Loading from '@/components/user/layout/LoadingComponent.vue';

export default{
	name: 'PackageViewComponent',
    components: {
        TopNavbar,
        MyPackageComponent,
        PackageInformationComponent,
		Loading
    },
}
</script>

<style>
</style>